<template>
  <div class="company-profile-wrapper">
    <!-- company-profile display -->
    <div
      class="company-profile-container"
      v-if="show_list"
      v-animate-css="'fadeIn'"
    >
      <div class="assignment-widget">
        <multipane class="custom-resizer" layout="vertical">
          <div class="all-assignment">
            <div class="all-assignment-container">
              <div class="assignments-header">
                <div class="assignments-item-header">
                  <label class="assignment-title">Assignments</label>
                  <div class="options">
                    <button class="add-btn" @click="showAddUpdateForm()">
                      Add Assignment +
                    </button>
                  </div>
                </div>
                <div class="search-add-btn-widget">
                  <div class="search-widget">
                    <img src="@/assets/icons/search.svg" alt />
                    <input
                      type="text"
                      v-model="search_assignment"
                      placeholder="Type in to Search…"
                    />
                  </div>
                </div>
                <div class="filter-widget" v-if="false">
                  <div class="filter-select-widget">
                    <img src="@/assets/admin-icon/briefcase.svg" />
                    <filter-select
                      v-model="tag_filter_data"
                      :content="tags_filter"
                      ><span style="color: #0884af"
                        >Add a job title</span
                      ></filter-select
                    >
                  </div>
                  <div class="filter-select-widget">
                    <img src="@/assets/admin-icon/map-marker.svg" />
                    <filter-select
                      v-model="tag_filter_data"
                      :content="tags_filter"
                      ><span style="color: #0884af"
                        >Add a location</span
                      ></filter-select
                    >
                  </div>
                  <div class="filter-select-widget">
                    <img src="@/assets/admin-icon/building.svg" />
                    <filter-select
                      v-model="tag_filter_data"
                      :content="tags_filter"
                      ><span style="color: #0884af"
                        >Add a department</span
                      ></filter-select
                    >
                  </div>
                </div>
                <div
                  class="search-result-count"
                  v-if="!showLoading && leads.length > 0"
                >
                  <span class="result-count"
                    >All Results ({{ leads.length | validate }})</span
                  >
                  <span v-if="false" class="sort-by">Sort by</span>
                  <select v-if="false" class="sort-input" name="">
                    <option value="newest">Newest</option>
                  </select>
                </div>
              </div>

              <div class="assingment-body">
                <ul class="assignments-items">
                  <li class="assignments-starter"></li>
                  <li
                    class="assignments-item"
                    v-for="(lead, i) in leads"
                    :key="i"
                  >
                    <div class="assignments-item-header">
                      <div class="assignments-item-brand">
                        <img
                          v-if="$hasKey(lead, 'user.customer_profile.logo')"
                          @click.prevent="
                            $router.push({
                              name: 'profile_customer',
                              params: { id: lead.user_id },
                            })
                          "
                          :src="
                            $fullUrl(
                              'images/profiles/' +
                                lead.user.customer_profile.logo
                            )
                          "
                        />
                        <img
                          v-else-if="$hasKey(lead, 'user.company_profile.logo')"
                          @click.prevent="
                            $router.push({
                              name: 'profile_customer',
                              params: { id: lead.user_id },
                            })
                          "
                          :src="
                            $fullUrl(
                              'images/profiles/' +
                                lead.user.company_profile.logo
                            )
                          "
                        />
                        <img
                          v-else
                          @click.prevent="
                            $router.push({
                              name: 'profile_customer',
                              params: { id: lead.user_id },
                            })
                          "
                          src="@/assets/icons/logo_avatar.svg"
                        />
                      </div>
                      <div class="content">
                        <div class="title-row">
                          <label>{{ lead.title | validate }}</label>
                          <p class="role">{{ lead.role | validate }}</p>
                          <label
                            v-if="
                              false &&
                              $hasKey(lead, 'user.company_profile.name')
                            "
                            >{{
                              lead.user.company_profile.name | validate
                            }}</label
                          >
                          <label v-show="false" v-else>{{
                            lead.customer | validate
                          }}</label>
                          <span v-if="lead.address" class="address-loaction"
                            ><img
                              width="10"
                              src="@/assets/admin-icon/green-map-marker.svg"
                            />
                            {{ lead.address | validate }}</span
                          >

                          <button
                            @click="lead.view_more = !lead.view_more"
                            class="btn-description"
                          >
                            Description
                            <img
                              v-if="!lead.view_more"
                              src="@/assets/admin-icon/blue-caret-down.svg"
                            />
                            <img
                              v-else
                              src="@/assets/admin-icon/blue-caret-up.svg"
                            />
                          </button>
                        </div>
                      </div>
                      <div class="assignment-image">
                        <img
                          class="cover-img"
                          :class="{ expanded: lead.view_more }"
                          :src="$fullUrl('images/profiles/' + lead.cover_photo)"
                          v-if="lead.cover_photo"
                          alt
                        />
                      </div>
                    </div>

                    <div class="assignments-item-body" v-if="lead.view_more">
                      <div class="assignments-info">
                        <p
                          class="assignment-desc"
                          v-readMore:200="lead.description"
                        ></p>
                        <div
                          class="assign-skills-widget"
                          v-if="lead.skills.length > 0"
                        >
                          <div
                            class="item"
                            v-for="(skill, i) in lead.skills"
                            :key="i"
                          >
                            <span class="name">{{ skill | validate }}</span>
                          </div>
                        </div>
                        <p>
                          {{ lead.due_date_from | formatDate | validate }}
                          <template v-if="lead.is_urgent"
                            >/ As soon as possible</template
                          >
                        </p>
                        <p class="rate">
                          {{ lead.rate | validate }}
                          <template v-if="lead.is_negotiable"
                            >/ Negotiable</template
                          >
                        </p>
                      </div>
                      <div class="posted-date">
                        <h4>
                          Posted
                          {{
                            moment(lead.created_at).format(
                              "dddd, MMMM Do YYYY, h:mm a"
                            ) | validate
                          }}
                        </h4>
                      </div>
                    </div>
                    <div class="item-option">
                      <button
                        class="btn-assing"
                        @click.prevent="assingConsultant(lead)"
                      >
                        Assign to consultant
                      </button>
                      <div class="assignment-time">
                        <div class="time">
                          <img src="@/assets/admin-icon/blue-clock.svg" />
                          <span>{{ lead.work_load | validate }}</span>
                          <span class="sepalator" v-if="lead.work_load">|</span>
                          <span>{{ lead.duration | validate }}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                class="company-profile-body"
                v-if="!showLoading && leads.length == 0"
              >
                <div class="empty-widget">
                  <div class="empty-widget-body">
                    <p>We don't have any public asignments yet</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <multipane-resizer></multipane-resizer>
          <div :style="{ flexGrow: 1 }" class="our-assingment">
            <div class="company-profile-body">
              <div class="tabs">
                <div
                  class="tab all"
                  :class="{ active: tab == 'all' }"
                  @click="tab = 'all'"
                >
                  All Assignments
                </div>
                <div
                  class="tab"
                  :class="{ active: tab == 'assing' }"
                  @click="tab = 'assing'"
                >
                  Assigned
                </div>
                <div
                  class="tab"
                  :class="{ active: tab == 'our' }"
                  @click="tab = 'our'"
                >
                  Our Assingment
                </div>
              </div>

              <!-- All assignment -->

              <div
                class="all-assignment-container all-assign"
                v-if="tab == 'all'"
              >
                <div class="assignments-header">
                  <div class="assignments-item-header">
                    <label>Assignments</label>
                    <div class="options">
                      <button class="add-btn" @click="showAddUpdateForm()">
                        Add Assignment +
                      </button>
                    </div>
                  </div>
                  <div class="search-add-btn-widget">
                    <div class="search-widget">
                      <img src="@/assets/icons/search.svg" alt />
                      <input
                        type="text"
                        v-model="search_assignment"
                        placeholder="Type in to Search…"
                      />
                    </div>
                  </div>
                  <div class="filter-widget" v-if="false">
                    <div class="filter-select-widget">
                      <img src="@/assets/admin-icon/briefcase.svg" />
                      <filter-select
                        v-model="tag_filter_data"
                        :content="tags_filter"
                        ><span style="color: #0884af"
                          >Add a job title</span
                        ></filter-select
                      >
                    </div>
                    <div class="filter-select-widget">
                      <img src="@/assets/admin-icon/map-marker.svg" />
                      <filter-select
                        v-model="tag_filter_data"
                        :content="tags_filter"
                        ><span style="color: #0884af"
                          >Add a location</span
                        ></filter-select
                      >
                    </div>
                    <div class="filter-select-widget">
                      <img src="@/assets/admin-icon/building.svg" />
                      <filter-select
                        v-model="tag_filter_data"
                        :content="tags_filter"
                        ><span style="color: #0884af"
                          >Add a department</span
                        ></filter-select
                      >
                    </div>
                  </div>
                </div>
                <div class="loader" ref="loader" v-show="showLoading"></div>
                <div class="search-result-count">
                  <span class="result-count"
                    >All Results ({{ leads.length | validate }})</span
                  >
                  <span v-if="false" class="sort-by">Sort by</span>
                  <select v-if="false" class="sort-input" name="">
                    <option value="newest">Newest</option>
                  </select>
                </div>
                <ul class="assignments-items">
                  <li class="assignments-starter"></li>
                  <li
                    class="assignments-item"
                    v-for="(lead, i) in leads"
                    :key="i"
                  >
                    <div class="assignments-item-header">
                      <div class="assignments-item-brand">
                        <img
                          v-if="$hasKey(lead, 'user.customer_profile.logo')"
                          @click.prevent="
                            $router.push({
                              name: 'profile_customer',
                              params: { id: lead.user_id },
                            })
                          "
                          :src="
                            $fullUrl(
                              'images/profiles/' +
                                lead.user.customer_profile.logo
                            )
                          "
                        />
                        <img
                          v-else-if="$hasKey(lead, 'user.company_profile.logo')"
                          @click.prevent="
                            $router.push({
                              name: 'profile_customer',
                              params: { id: lead.user_id },
                            })
                          "
                          :src="
                            $fullUrl(
                              'images/profiles/' +
                                lead.user.company_profile.logo
                            )
                          "
                        />
                        <img
                          v-else
                          @click.prevent="
                            $router.push({
                              name: 'profile_customer',
                              params: { id: lead.user_id },
                            })
                          "
                          src="@/assets/icons/logo_avatar.svg"
                        />
                      </div>
                      <div class="content">
                        <div class="title-row">
                          <label>{{ lead.title | validate }}</label>
                          <p class="role">{{ lead.role | validate }}</p>
                          <label
                            v-if="
                              false &&
                              $hasKey(lead, 'user.company_profile.name')
                            "
                            >{{
                              lead.user.company_profile.name | validate
                            }}</label
                          >
                          <label v-show="false" v-else>{{
                            lead.customer | validate
                          }}</label>
                          <span v-if="lead.address" class="address-loaction"
                            ><img
                              width="10"
                              src="@/assets/admin-icon/green-map-marker.svg"
                            />
                            {{ lead.address | validate }}</span
                          >

                          <button
                            @click="lead.view_more = !lead.view_more"
                            class="btn-description"
                          >
                            Description
                            <img
                              v-if="!lead.view_more"
                              src="@/assets/admin-icon/blue-caret-down.svg"
                            />
                            <img
                              v-else
                              src="@/assets/admin-icon/blue-caret-up.svg"
                            />
                          </button>
                        </div>
                      </div>
                      <div class="assignment-image">
                        <img
                          class="cover-img"
                          :class="{ expanded: lead.view_more }"
                          :src="$fullUrl('images/profiles/' + lead.cover_photo)"
                          v-if="lead.cover_photo"
                          alt
                        />
                      </div>
                    </div>

                    <div class="assignments-item-body" v-if="lead.view_more">
                      <div class="assignments-info">
                        <p
                          class="assignment-desc"
                          v-readMore:200="lead.description"
                        ></p>
                        <div
                          class="assign-skills-widget"
                          v-if="lead.skills.length > 0"
                        >
                          <div
                            class="item"
                            v-for="(skill, i) in lead.skills"
                            :key="i"
                          >
                            <span class="name">{{ skill | validate }}</span>
                          </div>
                        </div>
                        <p>
                          {{ lead.due_date_from | formatDate | validate }}
                          <template v-if="lead.is_urgent"
                            >/ As soon as possible</template
                          >
                        </p>
                        <p class="rate">
                          {{ lead.rate | validate }}
                          <template v-if="lead.is_negotiable"
                            >/ Negotiable</template
                          >
                        </p>
                      </div>
                      <div class="posted-date">
                        <h4>
                          Posted
                          {{
                            moment(lead.created_at).format(
                              "dddd, MMMM Do YYYY, h:mm a"
                            ) | validate
                          }}
                        </h4>
                      </div>
                    </div>
                    <div class="item-option">
                      <button
                        class="btn-assing"
                        @click.prevent="assingConsultant(lead)"
                      >
                        Assign to consultant
                      </button>
                      <div class="assignment-time">
                        <div class="time">
                          <img src="@/assets/admin-icon/blue-clock.svg" />
                          <span>{{ lead.work_load | validate }}</span>
                          <span class="sepalator" v-if="lead.work_load">|</span>
                          <span>{{ lead.duration | validate }}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div
                  class="company-profile-body"
                  v-if="leads.length == 0 && tab == 'inter'"
                >
                  <div class="empty-widget">
                    <div class="empty-widget-body">
                      <p>We don't have any public asignments yet</p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="company-profile-body"
                v-if="leads.length == 0 && tab == 'all'"
              >
                <div class="empty-widget">
                  <div class="empty-widget-body">
                    <p>We don't have any public asignments yet</p>
                  </div>
                </div>
              </div>
              <!-- End of all assignment -->
              <!-- Assigned  -->
              <ul class="assignments-items" v-if="tab == 'assing'">
                <li class="assignments-starter"></li>
                <li
                  class="assignments-item"
                  v-for="(lead, i) in user.assignment_assigned"
                  :key="i"
                >
                  <div class="assignments-item-header">
                    <div class="assignments-item-brand">
                      <img
                        v-if="$hasKey(lead, 'user.customer_profile.logo')"
                        @click.prevent="
                          $router.push({
                            name: 'profile_customer',
                            params: { id: lead.user_id },
                          })
                        "
                        :src="
                          $fullUrl(
                            'images/profiles/' + lead.user.customer_profile.logo
                          )
                        "
                      />
                      <img
                        v-else-if="$hasKey(lead, 'user.company_profile.logo')"
                        @click.prevent="
                          $router.push({
                            name: 'profile_customer',
                            params: { id: lead.user_id },
                          })
                        "
                        :src="
                          $fullUrl(
                            'images/profiles/' + lead.user.company_profile.logo
                          )
                        "
                      />
                      <img
                        v-else
                        @click.prevent="
                          $router.push({
                            name: 'profile_customer',
                            params: { id: lead.user_id },
                          })
                        "
                        src="@/assets/icons/logo_avatar.svg"
                      />
                    </div>
                    <div class="content">
                      <div class="title-row">
                        <label>{{ lead.title | validate }}</label>
                        <p class="role">{{ lead.role | validate }}</p>
                        <label
                          v-if="
                            false && $hasKey(lead, 'user.company_profile.name')
                          "
                          >{{
                            lead.user.company_profile.name | validate
                          }}</label
                        >
                        <label v-show="false" v-else>{{
                          lead.customer | validate
                        }}</label>
                        <span v-if="lead.address" class="address-loaction"
                          ><img
                            width="10"
                            src="@/assets/admin-icon/map-marker.svg"
                          />
                          {{ lead.address | validate }}</span
                        >

                        <button
                          @click="lead.view_more = !lead.view_more"
                          class="btn-description"
                        >
                          Description
                          <img
                            v-if="!lead.view_more"
                            src="@/assets/admin-icon/blue-caret-down.svg"
                          />
                          <img
                            v-else
                            src="@/assets/admin-icon/blue-caret-up.svg"
                          />
                        </button>
                      </div>
                    </div>
                    <div class="assignment-image">
                      <img
                        class="cover-img"
                        :class="{ expanded: lead.view_more }"
                        :src="$fullUrl('images/profiles/' + lead.cover_photo)"
                        v-if="lead.cover_photo"
                        alt
                      />
                    </div>
                  </div>

                  <div class="assignments-item-body" v-if="lead.view_more">
                    <div class="assignments-info">
                      <p
                        class="assignment-desc"
                        v-readMore:200="lead.description"
                      ></p>
                      <div class="assign-skills-widget">
                        <div
                          class="item"
                          v-for="(skill, i) in lead.skills"
                          :key="i"
                        >
                          <span class="name">{{ skill | validate }}</span>
                        </div>
                      </div>
                      <p>
                        {{ lead.due_date_from | formatDate | validate }}
                        <template v-if="lead.is_urgent"
                          >/ As soon as possible</template
                        >
                      </p>
                      <p class="rate">
                        {{ lead.rate | validate }}
                        <template v-if="lead.is_negotiable"
                          >/ Negotiable</template
                        >
                      </p>
                    </div>
                    <div class="posted-date">
                      <h4>
                        Posted
                        {{
                          moment(lead.created_at).format(
                            "dd, MMM Do YYYY, h:mm a"
                          ) | validate
                        }}
                      </h4>
                    </div>
                  </div>
                  <div class="item-option">
                    <div class="member-section">
                      <span class="assinged-label">Assigned</span>
                      <div class="collaboraters-widget">
                        <div
                          class="item"
                          v-for="(item, i) in lead.members"
                          :key="i"
                        >
                          <img
                            v-if="item.profile_picture"
                            class="profile-img"
                            :class="{ override: i > 0 }"
                            :src="
                              $fullUrl(
                                'images/profiles/' + item.profile_picture
                              )
                            "
                          />
                          <img
                            class="profile-img"
                            v-else
                            src="@/assets/icons/logo_avatar.svg"
                          />
                          <span class="name" v-if="lead.members.length == 1"
                            >{{ item.first_name | validate }}
                            {{ item.last_name | validate }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <button
                      v-if="false"
                      class="btn-assing"
                      @click.prevent="assingConsultant(lead)"
                    >
                      Assign to consultant
                    </button>
                    <div class="assignment-time">
                      <div class="time">
                        <img src="@/assets/admin-icon/blue-clock.svg" />
                        <span>{{ lead.work_load | validate }}</span>
                        <span class="sepalator" v-if="lead.work_load">|</span>
                        <span>{{ lead.duration | validate }}</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div
                class="empty-widget"
                v-if="user.assignment_assigned.length == 0 && tab == 'assing'"
              >
                <div class="empty-widget-body">
                  <p>You do no have any assigned asignments yet</p>
                </div>
              </div>
              <!-- End of assinged -->
              <!-- Our Assignment -->
              <ul class="assignments-items" v-if="tab == 'our'">
                <li class="assignments-starter"></li>
                <li
                  class="assignments-item"
                  v-for="(lead, i) in our_assignment"
                  :key="i"
                >
                  <div class="assignments-item-header">
                    <div class="assignments-item-brand">
                      <img
                        v-if="$hasKey(lead, 'user.customer_profile.logo')"
                        @click.prevent="
                          $router.push({
                            name: 'profile_customer',
                            params: { id: lead.user_id },
                          })
                        "
                        :src="
                          $fullUrl(
                            'images/profiles/' + lead.user.customer_profile.logo
                          )
                        "
                      />
                      <img
                        v-else-if="$hasKey(lead, 'user.company_profile.logo')"
                        @click.prevent="
                          $router.push({
                            name: 'profile_customer',
                            params: { id: lead.user_id },
                          })
                        "
                        :src="
                          $fullUrl(
                            'images/profiles/' + lead.user.company_profile.logo
                          )
                        "
                      />
                      <img
                        v-else
                        @click.prevent="
                          $router.push({
                            name: 'profile_customer',
                            params: { id: lead.user_id },
                          })
                        "
                        src="@/assets/icons/logo_avatar.svg"
                      />
                    </div>
                    <div class="content">
                      <div class="title-row">
                        <label>{{ lead.title | validate }}</label>
                        <p class="role">{{ lead.role | validate }}</p>
                        <label
                          v-if="
                            false && $hasKey(lead, 'user.company_profile.name')
                          "
                          >{{
                            lead.user.company_profile.name | validate
                          }}</label
                        >
                        <label v-show="false" v-else>{{
                          lead.customer | validate
                        }}</label>
                        <span v-if="lead.address" class="address-loaction"
                          ><img
                            width="10"
                            src="@/assets/admin-icon/map-marker.svg"
                          />
                          {{ lead.address | validate }}</span
                        >

                        <button
                          @click="lead.view_more = !lead.view_more"
                          class="btn-description"
                        >
                          Description
                          <img
                            v-if="!lead.view_more"
                            src="@/assets/admin-icon/blue-caret-down.svg"
                          />
                          <img
                            v-else
                            src="@/assets/admin-icon/blue-caret-up.svg"
                          />
                        </button>
                      </div>
                    </div>
                    <div class="assignment-image">
                      <img
                        class="cover-img"
                        :class="{ expanded: lead.view_more }"
                        :src="$fullUrl('images/profiles/' + lead.cover_photo)"
                        v-if="lead.cover_photo"
                      />
                    </div>
                    <dropdown-menu class="assi-menu">
                      <ul>
                        <li>
                          <a href @click.prevent="assingConsultant(lead)"
                            >Assign</a
                          >
                        </li>
                        <li v-if="lead.status == 0">
                          <a href @click.prevent="publish(lead.id)">Publish</a>
                        </li>
                        <li v-else>
                          <a href @click.prevent="unpublish(lead.id)">
                            Unpublish</a
                          >
                        </li>
                        <li>
                          <a href="#" @click.prevent="editAssignment(lead)"
                            >Edit</a
                          >
                        </li>
                        <li>
                          <app-dialog
                            title="Delete Assignment"
                            ask="Are you sure you want to permanently delete this assignment?"
                            yesText="Delete"
                            noText="Cancel"
                            yesBtnClass="btn-danger"
                            @onComfirm="deleteAssingment(lead, i)"
                          >
                            <a href="#">Delete</a>
                          </app-dialog>
                        </li>
                      </ul>
                    </dropdown-menu>
                  </div>

                  <div class="assignments-item-body" v-if="lead.view_more">
                    <div class="assignments-info">
                      <p
                        class="assignment-desc"
                        v-readMore:200="lead.description"
                      ></p>
                      <div class="assign-skills-widget">
                        <div
                          class="item"
                          v-for="(skill, i) in lead.skills"
                          :key="i"
                        >
                          <span class="name">{{ skill | validate }}</span>
                        </div>
                      </div>
                      <p>
                        {{ lead.due_date_from | formatDate | validate }}
                        <template v-if="lead.is_urgent"
                          >/ As soon as possible</template
                        >
                      </p>
                      <p class="rate">
                        {{ lead.rate | validate }}
                        <template v-if="lead.is_negotiable"
                          >/ Negotiable</template
                        >
                      </p>
                    </div>
                    <div class="posted-date">
                      <h4>
                        Posted
                        {{
                          moment(lead.created_at).format(
                            "dd, MMM Do YYYY, h:mm a"
                          ) | validate
                        }}
                      </h4>
                    </div>
                  </div>
                  <div class="item-option">
                    <button
                      class="btn-assing"
                      @click.prevent="assingConsultant(lead)"
                    >
                      Assign to consultant
                    </button>
                    <div class="assignment-time">
                      <div class="time">
                        <img src="@/assets/admin-icon/blue-clock.svg" />
                        <span>{{ lead.work_load | validate }}</span>
                        <span class="sepalator" v-if="lead.work_load">|</span>
                        <span>{{ lead.duration | validate }}</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div
                class="empty-widget"
                v-if="our_assignment.length == 0 && tab == 'our'"
              >
                <div class="empty-widget-body">
                  <p>You do no have any asignments yet</p>
                </div>
              </div>
              <!-- End of our assingment -->
            </div>
          </div>
        </multipane>
      </div>
    </div>
    <!-- End -->

    <!-- Add and Update form -->

    <add-assignment
      v-if="add_assignment_modal"
      @onClose="showList()"
      :value="assignment_selected_item"
      :company_id="user.company_info.id"
      @onFinish="afterAssignementAdded()"
    />

    <!-- Select consultant -->
    <div class="select-consultant-wrapper" v-if="show_select_consultants">
      <selectConsultants
        :value="assignment_selected_item"
        @onClose="show_select_consultants = false"
      />
    </div>
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import appDialog from "@/components/Dialog/AppDialog.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import Loading from "@/components/Loader/Loading";
import lottie from "lottie-web";
import * as animationData from "@/assets/json/loader";
import addAssignment from "@/components/Company/addAssignment.vue";
import selectConsultants from "@/components/Company/selectConsultants.vue";
export default {
  name: "Assignment",
  components: {
    panelExpand,
    appDialog,
    Loading,
    addAssignment,
    selectConsultants,
  },
  props: {},
  data: () => {
    return {
      tab: "assing",
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
        projects: [],
        assignment_assigned: [],
      },
      leads: [],
      add_assignment_modal: false,
      assignment_selected_item: null,
      search_assignment: "",
      showLoading: false,
      anim: null,
      show_list: true,
      show_select_consultants: false,
      our_assignment: [],
    };
  },
  mounted() {
    let vm = this;
    vm.anim = lottie.loadAnimation({
      container: vm.$refs.loader,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData.default,
    });
    vm.getAssignment();
    vm.getAllStartData();
    vm.getOurAssingment();
  },
  computed: {},
  methods: {
    assingConsultant(item) {
      let vm = this;
      vm.show_select_consultants = true;
      vm.assignment_selected_item = item;
    },
    getOurAssingment() {
      let vm = this;
      vm.$store
        .dispatch("GET_ASSIGNMENT")
        .then((responce) => {
          vm.our_assignment = responce.data.map((item) => {
            let roles = item.role;
            let skills = [];
            let loc = "";
            if (item.user) {
              if (item.user.customer_profile)
                eventBus.$set(
                  item,
                  "customer",
                  item.user.customer_profile.name
                );
              else eventBus.$set(item, "customer", item.user.username);
            } else eventBus.$set(item, "customer", "");

            eventBus.$set(item, "skills_data", item.skills);
            eventBus.$set(item, "address", item.address);
            eventBus.$set(item, "view_more", false);
            eventBus.$set(item, "more_skills", false);

            item.skills.forEach((skill) => {
              skill.roles.forEach((i) => {
                skills.push(i.name);
              });
              skill.tools.forEach((i) => {
                skills.push(i.name);
              });
              skill.domains.forEach((i) => {
                skills.push(i.name);
              });
              skill.competences.forEach((i) => {
                skills.push(i.name);
              });
              skill.languages.forEach((i) => {
                skills.push(i.name);
              });
            });
            item.roles = roles;
            eventBus.$set(item, "all_skills", skills);
            eventBus.$set(item, "less_skills", skills.slice(0, 3));
            item.skills = item.less_skills;

            return item;
          });
        })
        .catch((error) => {});
    },
    getAllStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;
          vm.user.assignment_assigned = vm.user.assignment_assigned.map(
            (item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);
              eventBus.$set(item, "view_more", false);
              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              eventBus.$set(item, "all_skills", skills);
              eventBus.$set(item, "less_skills", skills.slice(0, 3));
              item.skills = item.less_skills;
              return item;
            }
          );
        })
        .catch((error) => {});
    },
    showAddUpdateForm() {
      let vm = this;
      vm.add_assignment_modal = true;
      vm.assignment_selected_item = {};
      vm.show_list = true;
    },
    showList() {
      let vm = this;
      vm.add_assignment_modal = false;
      vm.show_list = true;
    },
    afterAssignementAdded() {
      let vm = this;
      vm.showList();
      vm.getAssignment();
      vm.getAllStartData();
      vm.getOurAssingment();
    },
    getAssignment() {
      let vm = this;
      vm.showLoading = true;
      vm.$store
        .dispatch("GET_ALL_ASSIGNMENT")
        .then((value) => {
          vm.showLoading = false;
          vm.leads = value.data.data.map((item) => {
            let roles = item.role;
            let skills = [];
            let loc = "";
            if (item.user) {
              if (item.user.customer_profile)
                eventBus.$set(
                  item,
                  "customer",
                  item.user.customer_profile.name
                );
              else eventBus.$set(item, "customer", item.user.username);
            } else eventBus.$set(item, "customer", "");

            eventBus.$set(item, "address", item.address);
            eventBus.$set(item, "view_more", false);
            eventBus.$set(item, "more_skills", false);

            item.skills.forEach((skill) => {
              skill.roles.forEach((i) => {
                skills.push(i.name);
              });
              skill.tools.forEach((i) => {
                skills.push(i.name);
              });
              skill.domains.forEach((i) => {
                skills.push(i.name);
              });
              skill.competences.forEach((i) => {
                skills.push(i.name);
              });
              skill.languages.forEach((i) => {
                skills.push(i.name);
              });
            });
            item.roles = roles;
            eventBus.$set(item, "all_skills", skills);
            eventBus.$set(item, "less_skills", skills.slice(0, 3));
            item.skills = item.less_skills;

            return item;
          });
        })
        .catch((reason) => {
          vm.showLoading = false;
          console.log(reason);
        });
    },
    searchAssignment(string) {
      let vm = this;
      vm.showLoading = true;
      if (vm.tab == "all") {
        vm.$store
          .dispatch("SEARCH_ASSIGNMENT", { query: string })
          .then((value) => {
            vm.showLoading = false;
            vm.leads = value.data.map((item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);
              eventBus.$set(item, "view_more", false);
              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              item.skills = skills;

              return item;
            });
          })
          .catch((error) => {
            vm.showLoading = false;
            console.error({ error });
          });
      } else if (vm.tab == "assing") {
        vm.$store
          .dispatch("SEARCH_ASIGNED_ASSIGNMENT", { query: string })
          .then((value) => {
            vm.showLoading = false;
            vm.user.assignment_assigned = value.data.map((item) => {
              let roles = item.role;
              let skills = [];
              let loc = "";
              if (item.user) {
                if (item.user.customer_profile)
                  eventBus.$set(
                    item,
                    "customer",
                    item.user.customer_profile.name
                  );
                else eventBus.$set(item, "customer", item.user.username);
              } else eventBus.$set(item, "customer", "");

              eventBus.$set(item, "address", item.address);
              eventBus.$set(item, "view_more", false);
              eventBus.$set(item, "more_skills", false);

              item.skills.forEach((skill) => {
                skill.roles.forEach((i) => {
                  skills.push(i.name);
                });
                skill.tools.forEach((i) => {
                  skills.push(i.name);
                });
                skill.domains.forEach((i) => {
                  skills.push(i.name);
                });
                skill.competences.forEach((i) => {
                  skills.push(i.name);
                });
                skill.languages.forEach((i) => {
                  skills.push(i.name);
                });
              });
              item.roles = roles;
              item.skills = skills;

              return item;
            });
          })
          .catch((error) => {
            vm.showLoading = false;
            console.error({ error });
          });
      }
    },
    deleteAssingment(item, i) {
      let vm = this;
      vm.$store
        .dispatch("DELETE_ASSIGNMENT", { id: item.id })
        .then((response) => {
          vm.our_assignment.splice(i, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editAssignment(item) {
      let vm = this;
      vm.assignment_selected_item = null;
      vm.add_assignment_modal = true;
      vm.assignment_selected_item = item;
      vm.show_list = true;
    },
    unpublish(id) {
      let vm = this;
      vm.$store
        .dispatch("UNPUBLISH_ASSIGNMENT", { id: id })
        .then((response) => {
          vm.getAssignment();
          vm.getAllStartData();
          vm.getOurAssingment();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    publish(id) {
      let vm = this;
      vm.$store
        .dispatch("PUBLISH_ASSIGNMENT", { id: id })
        .then((response) => {
          vm.getAssignment();
          vm.getAllStartData();
          vm.getOurAssingment();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    search_assignment: function (val) {
      if (val != "") {
        this.searchAssignment(val);
      } else {
        this.getAssignment();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.company-profile-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .company-profile-container {
    padding: 10px;
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    .assignment-widget {
      height: 100%;
      width: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      .custom-resizer {
        height: 100%;
      }
      .all-assignment {
        height: 100%;
        min-width: calc(100% - 700px);
        background: #fff;
        width: 100%;
        border-radius: 5px;
        padding: 20px;
        display: flex;
        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
        .all-assignment-container {
          height: 100%;
          display: flex;
          flex-direction: column;
          .assignments-header {
            background: #fff;
            border-radius: 5px;
            padding-bottom: 0px;
            height: 146px;
            .assignments-item-header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              .assignment-title {
                font-size: 25px;
              }
              .options {
                .add-btn {
                  color: #1885ad;
                  display: flex;
                  font-style: italic;
                  outline: none;
                }
              }
            }
            .search-add-btn-widget {
              display: grid;
              grid-template-columns: 100%;
              grid-column-gap: 20px;
              .search-widget {
                border: 1px solid #ccc;
                height: 45px;
                display: flex;
                align-items: center;
                padding: 0px 10px;
                border-radius: 5px;
                img {
                  width: 25px;
                  height: 25px;
                }
                input {
                  height: 43px;
                  width: 100%;
                  padding-left: 15px;
                  outline: none;
                  border: none;
                }
              }
              .add-btn {
                width: 191px;
                height: 45px;
                background: #1885ad 0% 0% no-repeat padding-box;
                border-radius: 5px;
                opacity: 1;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  margin-left: 10px;
                }
              }
            }
            .filter-widget {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .filter-select-widget {
                width: 188px;
                background: #f0f2f6;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
                img {
                  margin-top: -8px;
                  margin-right: 6px;
                }
              }
            }
            .search-result-count {
              padding: 20px 0px;
              .result-count {
                font-size: 15px;
                font-weight: 800;
                margin-right: 20px;
              }
              .sort-by {
                margin-right: 5px;
              }
              .sort-input {
                background: #fff;
                border: 1px solid #ccc;
                width: 130px;
                height: 31px;
                padding: 0 4px;
              }
            }
          }
          .assingment-body {
            overflow-y: auto;
            height: calc(100% - 146px);
            .loader {
              height: 80px;
              margin-top: 10px;
              background: #fff;
              position: relative;
              padding: 10px 0 0 0;
              -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
              border-radius: 5px;
              margin-bottom: 20px;
              svg {
                width: 70px !important;
              }
            }
            ul.assignments-items {
              list-style: none;
              padding-left: 0px;
              margin: 0px;
              border-bottom-left-radius: 5px;
              border-bottom-right-radius: 5px;
              @media (min-width: 300px) and (max-width: 630px) {
                padding: 0px 0px;
              }
              .assignments-starter {
                margin-bottom: 6px;
                .assignments-item-header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 16px 0px;
                  label {
                    color: #000000;
                    font-family: "AvenirBook";
                    font-size: 16px;
                  }
                  .btn-add-assignment {
                    color: #1ba5a4;
                    border: none;
                    padding: 10px 10px;
                    font-size: 14px;
                    outline: none;
                    cursor: pointer;
                    font-family: "AvenirBook";
                    font-style: italic;
                    background: transparent;
                  }
                }
                p {
                  color: #131313;
                  font-family: "AvenirBook";
                }
              }
              .assignments-item {
                background: #ffffff;
                border-radius: 5px;
                margin-bottom: 10px;
                position: relative;
                border: 1px solid rgb(223, 223, 223);
                @media (min-width: 300px) and (max-width: 630px) {
                  padding: 0px 0px;
                }
                .assignments-item-header {
                  display: flex;
                  padding: 10px 14px;

                  .assignments-item-brand {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 60px;
                    height: 60px;
                    @media (min-width: 300px) and (max-width: 630px) {
                      width: 60px;
                      height: 60px;
                    }
                    img {
                      width: 50px;
                      height: 50px;
                      border-radius: 50%;
                      object-fit: cover;
                      @media (min-width: 300px) and (max-width: 630px) {
                        width: 50px;
                        height: 50px;
                      }
                    }
                  }
                  .content {
                    display: flex;
                    width: 62%;
                    padding-right: 5px;
                    padding-left: 10px;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding-top: 6px;
                    .title-row {
                      width: 100%;
                      font-family: "AvenirBook";
                      label {
                        font-size: 20px;
                        font-family: "AvenirBook";
                        margin-bottom: 1px;
                        font-weight: 800;
                        color: #000;
                        margin-bottom: 5px;
                        overflow: hidden;
                        text-decoration: none;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width: 93%;
                        display: block;
                      }
                      p.role {
                        margin: 0px;
                        font-size: 16px;
                        margin-bottom: 5px;
                        overflow: hidden;
                        text-decoration: none;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width: 93%;
                        display: block;
                        color: #6c6c6c;
                      }
                      .address-loaction {
                        color: #1ba5a4;
                        margin-bottom: 5px;
                        font-size: 14px;
                        overflow: hidden;
                        text-decoration: none;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width: 93%;
                        display: block;
                      }

                      span.date {
                        color: #808080;
                        font-family: "AvenirBook";
                        font-size: 13px;
                        margin-bottom: 2px;
                        display: block;
                        margin-bottom: 5px;
                      }
                      .btn-description {
                        color: #0884af;
                        margin-left: -4px;
                        margin-top: 4px;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        img {
                          width: 12px;
                          margin-left: 6px;
                        }
                      }
                    }
                    .options {
                      display: flex;
                      align-items: flex-end;
                      flex-direction: column;
                      .date {
                        color: #808080;
                        font-family: "AvenirBook";
                        font-size: 13px;
                        display: flex;
                        justify-content: flex-end;
                        width: 188px;
                        align-items: center;
                        .separator {
                          margin: 0px 5px;
                        }
                        @media (min-width: 300px) and (max-width: 630px) {
                          font-size: 11px;
                          width: 145px;
                        }
                      }
                      .status {
                        color: #000;
                        font-family: "AvenirBook";
                        font-size: 13px;
                      }

                      .publish-btn,
                      .un-publish-btn {
                        border: 1px solid #2f90b6;
                        border-radius: 5px;
                        padding: 6px 20px;
                        color: #2f90b6;
                        background: transparent;
                        cursor: pointer;
                      }
                    }
                  }
                  .assignment-image {
                    width: 30%;
                    .cover-img {
                      width: 100%;
                      height: 96px;
                      object-fit: cover;
                      border-radius: 5px;
                      transition: 800ms ease-in-out;
                      &.expanded {
                        height: 72px;
                        transition: 800ms ease-in-out;
                      }
                    }
                  }
                  .toogle-panel-btn {
                    padding: 1px 7px;
                    font-size: 16px;
                    background: transparent;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    color: #ccc;
                    position: absolute;
                    bottom: 10px;
                    right: 5px;
                    height: 15px;
                  }
                }
                .assignments-item-body {
                  padding-left: 85px;
                  padding-right: 20px;
                  padding-bottom: 15px;
                  .assignment-desc {
                    color: #707070;
                    margin-bottom: 11px;
                  }
                  .assign-skills-widget {
                    padding: 0px 0px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 5px;
                    .item {
                      background: #1ba5a4;
                      border-radius: 20px;
                      display: flex;
                      align-items: center;
                      padding: 4px 38px;
                      margin-right: 8px;
                      margin-bottom: 8px;
                      .name {
                        color: #fff;
                      }
                    }
                  }

                  p {
                    text-align: left;
                    color: #000;
                    font-size: 13px;
                    font-weight: 800;
                    margin: 0px;
                  }
                  .rate {
                    margin-top: 10px;
                  }

                  .posted-date {
                    display: flex;
                    justify-content: flex-end;
                    margin-top: -15px;
                    h4 {
                      color: rgb(116, 116, 116);
                      font-style: italic;
                      margin: 0px;
                    }
                  }
                }
                .item-option {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 5px 20px;
                  border-top: 1px solid rgb(223, 223, 223);
                  .btn-assing {
                    background: #0884af;
                    border-radius: 4px;
                    height: 35px;
                    color: #fff;
                    padding: 0px 15px;
                  }
                  .assignment-time {
                    color: #1ba5a4;
                    .time {
                      display: flex;
                      align-items: center;
                      img {
                        width: 15px;
                        margin-right: 5px;
                        margin-top: -4px;
                      }
                    }
                    .sepalator {
                      margin: 0 5px;
                    }
                    span {
                      color: #1ba5a4;
                    }
                  }
                }
              }
            }
            .empty-widget {
              background: #fff;
              padding: 20px;
              .empty-widget-body {
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                p {
                  text-align: center;
                  width: 270px;
                }
                .add-btn {
                  width: 180px;
                  height: 45px;
                  background: #1890a9 0% 0% no-repeat padding-box;
                  border-radius: 4px;
                  color: #fff;
                  outline: none;
                  margin-right: 20px;
                  display: center;
                  justify-content: center;
                }
              }
            }
          }
        }
      }
      .our-assingment {
        height: 100%;
        overflow-y: auto;
        padding-bottom: 40px;
        width: 400px;
        min-width: 400px;
        max-width: 700px;
        border-radius: 5px;
        background: #fff;
        @media (min-width: 300px) and (max-width: 630px) {
          padding: 0px 0px;
        }
        .company-profile-body {
          border-radius: 5px;
          background: #fff;
          .tabs {
            display: grid;
            grid-template-columns: 50% 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 33.333% 33.333% 33.333%;
            }

            .tab:nth-child(1) {
              border-top-left-radius: 5px;
            }
            .tab:nth-child(3) {
              border-top-right-radius: 5px;
            }
            .tab {
              background: #cccccc;
              height: 55px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: 500ms ease-in-out;
              &.active {
                background: #fff;
                color: #1ba5a4;
                font-weight: 800;
                transition: 500ms ease-in-out;
                border-bottom: 2px solid #1ba5a4;
              }
              &:hover {
                color: #1ba5a4;
              }
            }
            .all {
              display: none;
              @media (min-width: 300px) and (max-width: 630px) {
                display: flex;
              }
            }
          }
          .assignments-item-header {
            display: flex;
            justify-content: space-between;
            padding: 24px 22px;
            .options {
              .add-btn {
                color: #1885ad;
                display: flex;
                font-style: italic;
                outline: none;
              }
            }
          }
          .search-add-btn-widget {
            background: #fff;
            padding: 0px 20px;
            display: grid;
            grid-template-columns: 100%;
            grid-column-gap: 20px;
            .search-widget {
              border: 1px solid #ccc;
              height: 45px;
              display: flex;
              align-items: center;
              padding: 0px 10px;
              border-radius: 5px;
              img {
                width: 25px;
                height: 25px;
              }
              input {
                height: 43px;
                width: 100%;
                padding-left: 15px;
                outline: none;
                border: none;
              }
            }
            .add-btn {
              width: 191px;
              height: 45px;
              background: #1885ad 0% 0% no-repeat padding-box;
              border-radius: 5px;
              opacity: 1;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                margin-left: 10px;
              }
            }
          }
          .loader {
            height: 80px;
            margin-top: 10px;
            background: #fff;
            position: relative;
            padding: 10px 0 0 0;
            -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            margin-bottom: 20px;
            svg {
              width: 70px !important;
            }
          }

          .all-assign {
            display: none;
            @media (min-width: 300px) and (max-width: 630px) {
              display: block;
            }
            .assignments-header {
              .assignments-item-header {
                @media (min-width: 300px) and (max-width: 630px) {
                  padding: 10px 10px;
                }
              }
              .search-add-btn-widget {
                @media (min-width: 300px) and (max-width: 630px) {
                  padding: 10px 10px;
                }
              }
            }
          }

          ul.assignments-items {
            background: #ffffff;
            padding: 0px 20px;
            padding-bottom: 20px;
            list-style: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            @media (min-width: 300px) and (max-width: 630px) {
              padding: 0px 10px;
            }

            .assignments-starter {
              margin-bottom: 6px;
              .assignments-item-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 16px 0px;
                label {
                  color: #000000;
                  font-family: "AvenirBook";
                  font-size: 16px;
                }
                .btn-add-assignment {
                  color: #1ba5a4;
                  border: none;
                  padding: 10px 10px;
                  font-size: 14px;
                  outline: none;
                  cursor: pointer;
                  font-family: "AvenirBook";
                  font-style: italic;
                  background: transparent;
                }
              }
              p {
                color: #131313;
                font-family: "AvenirBook";
              }
            }
            .assignments-item {
              background: #ffffff;
              border-radius: 5px;
              margin-bottom: 10px;
              position: relative;
              border: 1px solid rgb(223, 223, 223);
              @media (min-width: 300px) and (max-width: 630px) {
                padding: 0px 0px;
              }
              .assignments-item-header {
                display: flex;
                padding: 10px 14px;

                .assignments-item-brand {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 60px;
                  height: 60px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 60px;
                    height: 60px;
                  }
                  img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    object-fit: cover;
                    @media (min-width: 300px) and (max-width: 630px) {
                      width: 50px;
                      height: 50px;
                    }
                  }
                }
                .content {
                  display: flex;
                  width: 62%;
                  padding-right: 5px;
                  padding-left: 10px;
                  justify-content: space-between;
                  align-items: flex-start;
                  padding-top: 6px;
                  .title-row {
                    width: 100%;
                    font-family: "AvenirBook";
                    label {
                      font-size: 20px;
                      font-family: "AvenirBook";
                      margin-bottom: 1px;
                      font-weight: 800;
                      color: #000;
                      margin-bottom: 5px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 93%;
                      display: block;
                    }
                    p.role {
                      margin: 0px;
                      font-size: 16px;
                      margin-bottom: 5px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 93%;
                      display: block;
                      color: #6c6c6c;
                    }
                    .address-loaction {
                      color: #1ba5a4;
                      margin-bottom: 5px;
                      font-size: 14px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 93%;
                      display: block;
                    }

                    span.date {
                      color: #808080;
                      font-family: "AvenirBook";
                      font-size: 13px;
                      margin-bottom: 2px;
                      display: block;
                      margin-bottom: 5px;
                    }
                    .btn-description {
                      color: #0884af;
                      margin-left: -4px;
                      margin-top: 4px;
                      font-size: 14px;
                      display: flex;
                      align-items: center;
                      img {
                        width: 12px;
                        margin-left: 6px;
                      }
                    }
                  }
                  .options {
                    display: flex;
                    align-items: flex-end;
                    flex-direction: column;
                    .date {
                      color: #808080;
                      font-family: "AvenirBook";
                      font-size: 13px;
                      display: flex;
                      justify-content: flex-end;
                      width: 188px;
                      align-items: center;
                      .separator {
                        margin: 0px 5px;
                      }
                      @media (min-width: 300px) and (max-width: 630px) {
                        font-size: 11px;
                        width: 145px;
                      }
                    }
                    .status {
                      color: #000;
                      font-family: "AvenirBook";
                      font-size: 13px;
                    }

                    .publish-btn,
                    .un-publish-btn {
                      border: 1px solid #2f90b6;
                      border-radius: 5px;
                      padding: 6px 20px;
                      color: #2f90b6;
                      background: transparent;
                      cursor: pointer;
                    }
                  }
                }
                .assignment-image {
                  width: 30%;
                  .cover-img {
                    width: 100%;
                    height: 96px;
                    object-fit: cover;
                    border-radius: 5px;
                    transition: 800ms ease-in-out;
                    &.expanded {
                      height: 72px;
                      transition: 800ms ease-in-out;
                    }
                  }
                }
                .toogle-panel-btn {
                  padding: 1px 7px;
                  font-size: 16px;
                  background: transparent;
                  border: none;
                  outline: none;
                  cursor: pointer;
                  color: #ccc;
                  position: absolute;
                  bottom: 10px;
                  right: 5px;
                  height: 15px;
                }
              }
              .assignments-item-body {
                padding-left: 80px;
                padding-right: 20px;
                padding-bottom: 15px;
                .assignment-desc {
                  color: #707070;
                  margin-bottom: 11px;
                }
                .assign-skills-widget {
                  padding: 0px 0px;
                  display: flex;
                  flex-wrap: wrap;
                  margin-bottom: 5px;
                  .item {
                    background: #1ba5a4;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    padding: 4px 38px;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    .name {
                      color: #fff;
                    }
                  }
                }

                p {
                  text-align: left;
                  color: #000;
                  font-size: 13px;
                  font-weight: 800;
                  margin: 0px;
                }
                .rate {
                  margin-top: 10px;
                }

                .posted-date {
                  display: flex;
                  justify-content: flex-end;
                  margin-top: 2px;
                  h4 {
                    color: rgb(116, 116, 116);
                    font-style: italic;
                    margin: 0px;
                  }
                }
              }
              .item-option {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 5px 20px;
                border-top: 1px solid rgb(223, 223, 223);
                .member-section {
                  display: flex;
                  align-items: center;
                  .assinged-label {
                    height: 30px;
                    color: #fff;
                    background: #1ba5a4;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 80px;
                    margin-right: 8px;
                  }
                  .collaboraters-widget {
                    display: flex;
                    align-items: center;
                    .item {
                      display: flex;
                      align-items: center;
                      .profile-img {
                        width: 18px;
                        height: 18px;
                        border-radius: 50%;
                        border: 1px solid #ddd;
                        background: #fff;
                        &.override {
                          position: relative;
                          left: -5px;
                        }
                      }
                    }
                  }
                }
                .btn-assing {
                  background: #0884af;
                  border-radius: 4px;
                  height: 35px;
                  color: #fff;
                  padding: 0px 15px;
                }
                .assignment-time {
                  color: #1ba5a4;
                  .time {
                    display: flex;
                    align-items: center;
                    img {
                      width: 15px;
                      margin-right: 5px;
                      margin-top: -4px;
                    }
                  }
                  .sepalator {
                    margin: 0 5px;
                  }
                  span {
                    color: #1ba5a4;
                  }
                }
              }
            }
          }
          .empty-widget {
            background: #fff;
            padding: 20px;
            .empty-widget-body {
              height: 150px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              p {
                text-align: center;
                width: 270px;
              }
              .add-btn {
                width: 180px;
                height: 45px;
                background: #1890a9 0% 0% no-repeat padding-box;
                border-radius: 4px;
                color: #fff;
                outline: none;
                margin-right: 20px;
                display: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }
  .information-container {
    background: #f5f5f5 0% 0% no-repeat padding-box;
    border-radius: 5px;
    padding: 40px;
    .information-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      .information-brand {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 100px;
          margin-right: 20px;
        }
        span {
          font-family: "AvenirBook";
        }
      }
      .information-options {
        .btn-edit-info {
          box-shadow: 0px 1px 3px #00000029;
          border: 1px solid #36adae;
          border-radius: 5px;
          color: #1885ad;
          padding: 10px 50px;
          font-family: "AvenirBook";
        }
      }
    }
    .information-body {
      padding: 20px;
      ul {
        margin-left: -38px;
        list-style: none;
        .information-item {
          margin-bottom: 30px;
          label {
            color: #808080;
            font-family: "AvenirBook";
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>